var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.Bitmovin = youbora.StandardAdapter.extend({
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  getPlayhead: function () {
    return this.player.getCurrentTime()
  },

  getDuration: function () {
    return this.player.getDuration()
  },

  getPlayrate: function () {
    if (this.flags.isPaused) return 0
    if (typeof this.player.getPlaybackSpeed() !== "undefined") {
      return this.player.getPlaybackSpeed()
    }
    return 1
  },

  getDroppedFrames: function () {
    return this.player.getDroppedFrames()
  },

  getBitrate: function () {
    if (this.player.getPlaybackVideoData && this.player.getPlaybackVideoData()
      && this.player.getPlaybackVideoData().bitrate) {
      return this.player.getPlaybackVideoData().bitrate
    } else {
      return -1
    }
  },

  getRendition: function () {
    if (this.player.getPlaybackVideoData && this.player.getPlaybackVideoData()) {
      var playbackValues = this.player.getPlaybackVideoData()
      if (playbackValues.bitrate) {
        if (playbackValues.width && playbackValues.height) {
          return youbora.Util.buildRenditionString(playbackValues.width, playbackValues.height, playbackValues.bitrate)
        }
        return playbackValues.bitrate
      }
      return this.player.getPlaybackVideoData().id
    }
    return -1;
  },

  getIsLive: function () {
    return this.player.isLive()
  },

  getResource: function () {
    if (this.player.getConfig) {
      var sourceObject = this.player.getConfig().source
      if (sourceObject) {
        return sourceObject.dash || sourceObject.hls || sourceObject.progressive
      }
    }
    return 'unknown'
  },

  getPlayerName: function () {
    return "Bitmovin"
  },

  getPlayerVersion: function () {
    return bitmovin.player.version
  },

  initializeAdapter: function () {
    this.monitorPlayhead(true, true)
  },

  getListenersList: function () {
    var EVENT = this.player.EVENT || bitmovin.player.EVENT
    return [{
      suscriber: 'addEventHandler',
      unsuscriber: 'removeEventHandler',
      events: {
        [EVENT.ON_AD_CLICKED]: null,
        [EVENT.ON_AD_ERROR]: null,
        [EVENT.ON_AD_FINISHED]: null,
        [EVENT.ON_AD_LINEARITY_CHANGED]: null,
        [EVENT.ON_AD_MANIFEST_LOADED]: null,
        [EVENT.ON_AD_PLAYBACK_FINISHED]: null,
        [EVENT.ON_AD_SCHEDULED]: null,
        [EVENT.ON_AD_SKIPPED]: null,
        [EVENT.ON_AD_STARTED]: null,
        [EVENT.ON_DOWNLOAD_FINISHED]: null,
        [EVENT.ON_DVR_WINDOW_EXCEEDED]: null,
        [EVENT.ON_ERROR]: this.errorListener,
        [EVENT.ON_FULLSCREEN_ENTER]: null,
        [EVENT.ON_FULLSCREEN_EXIT]: null,
        [EVENT.ON_HIDE_CONTROLS]: null,
        [EVENT.ON_METADATA]: null,
        [EVENT.ON_PAUSED]: this.pauseListener,
        [EVENT.ON_PLAY]: this.playListener,
        [EVENT.ON_PLAYING]: this.playingListener,
        [EVENT.ON_PLAYBACK_FINISHED]: this.endedListener,
        [EVENT.ON_PLAYER_CREATED]: null,
        [EVENT.ON_PLAYER_RESIZE]: null,
        [EVENT.ON_READY]: null,
        [EVENT.ON_SEEK]: this.seekingListener,
        [EVENT.ON_SEEKED]: this.seekedListener,
        [EVENT.ON_SEGMENT_PLAYBACK]: this.joinListener,
        [EVENT.ON_SEGMENT_REQUEST_FINISHED]: null,
        [EVENT.ON_SOURCE_LOADED]: null,
        [EVENT.ON_SOURCE_UNLOADED]: null,
        [EVENT.ON_STALL_ENDED]: null,
        [EVENT.ON_STALL_STARTED]: null,
        [EVENT.ON_STOP_BUFFERING]: this.joinListener,
        [EVENT.ON_TIME_CHANGED]: this.joinChangedListener,
        [EVENT.ON_TIME_SHIFT]: null,
        [EVENT.ON_TIME_SHIFTED]: null,
        [EVENT.ON_VIDEO_ADAPTATION]: null,
        [EVENT.ON_VIDEO_DOWNLOAD_QUALITY_CHANGE]: null,
        [EVENT.ON_VIDEO_DOWNLOAD_QUALITY_CHANGED]: null,
        [EVENT.ON_VIDEO_PLAYBACK_QUALITY_CHANGED]: null,
        [EVENT.ON_VR_ERROR]: null,
        [EVENT.ON_VR_MODE_CHANGED]: null,
        [EVENT.ON_WARNING]: null,
        [EVENT.ON_SEGMENT_PLAYBACK]: null,
        [EVENT.ON_STALL_ENDED]: null,
        [EVENT.ON_STALL_STARTED]: null
      }
    }]
  },

  /** Listener for 'ON_PLAY' event. */
  playListener: function (e) {
    this.fireStart()
    this.fireResume()
  },

  /** Listener for 'ON_SEGMENT_PLAYBACK' and 'ON_STOP_BUFFERING' events. */
  joinListener: function (e) {
    this.fireJoin()
  },

  /** Listener for 'ON_PAUSED' event. */
  pauseListener: function (e) {
    if (!this.flags.isSeeking) this.firePause()
  },

  /** Listener for 'ON_PLAYING' events. */
  playingListener: function (e) {
    this.fireStart()
  },

  /** Listener for 'ON_ERROR' event. */
  errorListener: function (e) {
    this.fireError(e.code, e.message)
    // 200, 303, 403, 404, 405, 900, 901 Advertisement
    // 1000 to 1028 Setup error
    // 2000, 2001, 2002, 3000 to 3047 Error
    // 5000 to 5013 Warning
    if (e.code >= 1000 && e.code <= 4999) {
      this.fireStop()
    }
  },

  /** Listener for 'ON_SEEK' event. */
  seekingListener: function (e) {
    this.fireSeekBegin()
  },

  /** Listener for 'ON_SEEKED' event. */
  seekedListener: function (e) {
    this.monitor.skipNextTick()
  },

  /** Listener for 'ON_PLAYBACK_FINISHED' event. */
  endedListener: function (e) {
    this.fireStop()
  },

  /** Listener for 'ON_TIME_CHANGED' event*/
  joinChangedListener: function (e) {
    if (this.getPlayhead() > 0) {
      this.fireStart()
      this.fireJoin()
    }
  }
})

module.exports = youbora.adapters.Bitmovin
